import { FC } from 'react';
import { useMotion } from '../../common';
import { useAssetsCssProperties } from './assets';

import './style.scss';

export const Motion: FC = () => {
  const assetsCssProperties = useAssetsCssProperties();
  const { motionRef, showImage } = useMotion({
    loading: 3,
    MOTION_REAL_HEIGHT: 1150,
    MOTION_REAL_WIDTH: 900,
  });

  return (
    <div className="motion-lemo" ref={motionRef}>
      <div className="motion-lemo-layer-0" style={showImage ? assetsCssProperties : {}}>
        <div className="motion-lemo-layer-3">
          <div className="motion-lemo-layer-3-position">
            <div className="motion-lemo-layer-3-rotation">
              <div className="motion-lemo-layer-3-content"></div>
            </div>
          </div>
        </div>
        <div className="motion-lemo-layer-1">
          <div className="motion-lemo-layer-1-position">
            <div className="motion-lemo-layer-1-opacity">
              <div className="motion-lemo-layer-1-rotation">
                <div className="motion-lemo-layer-1-content">
                  <div className="motion-lemo-layer-2">
                    <div className="motion-lemo-layer-2-opacity">
                      <div className="motion-lemo-layer-2-content"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
